import React from 'react'
import { useTheme } from 'contexts/theme'

const LightDarkImage = ({ lightSrc, darkSrc, alt, ...props }) => {
    const { name, userPreferredName } = useTheme()

    if(!lightSrc) {
        return null
    }

    const dev = process.env.NODE_ENV === 'development'

    if(dev) {
        if(!alt) {
            console.warn('alt attribute is required')
        }

        if(!darkSrc) {
            console.warn('darkSrc attribute is recommended. Fallbacking to lightSrc')
            darkSrc = lightSrc
        }
    }

    const isDark = name === 'dark' || (name === 'system' && userPreferredName === 'dark')

    return (
        <picture {...props}>
            <source
                srcSet={darkSrc}
                media={isDark ? 'all' : 'none'} />
            <img
                src={lightSrc}
                alt={alt} />
        </picture>
    )
}

export default LightDarkImage